/* eslint-disable react/jsx-fragments */
import React, { Fragment, useCallback } from 'react';
import { connect } from 'react-redux';
import Modal from './Modal';
import { showModal, hideModal } from '../../actions/modal';
import screen from '../../refresh/constants/pageType.constant';
import { gtmPromotionCmsClick, gtmLuxePromotionCmsClick } from '../../modules/ga/GTMdatalayer';

const Link = props => {
  const {
    hotspotUrl,
    width,
    height,
    x,
    y,
    metadata,
    showModal,
    hideModal,
    variant = 'desktop',
    gtmPosition,
    gtmWidth,
    gtmHeight,
    gtmImgname,
    gtmId,
    storeType
  } = props;
  const openModal = useCallback(
    () =>
      showModal('video-image-modal', {
        state: {
          hotspotUrl,
          width,
          height,
          x,
          y,
          metadata,
          showModal,
          hideModal,
          variant
        }
      }),
    []
  );
  return (
    <Fragment>
      <div
        role="presentation"
        style={{
          position: 'absolute',
          left: `${x}%`,
          top: `${y}%`,
          width: `${width}%`,
          height: `${height}%`
        }}
        onClick={event => {
          const luxe = storeType?.toLowerCase() === 'luxe';
          const { location: { pathname: pageRoute = '' } = {} } = window || {};
          const isLandingPage = pageRoute.includes('shop');

          let { landing: { pageName = '', pageType = '' } = {} } = screen;
          pageName = '';
          if (!isLandingPage) {
            pageType = 'home screen';
          }

          let promoCreativeName = null;
          if (gtmWidth && gtmHeight && parseInt(gtmWidth) !== 0 && parseInt(gtmHeight) !== 0) {
            promoCreativeName = `${gtmWidth}x${gtmHeight}`;
          }

          luxe
            ? gtmLuxePromotionCmsClick(
                gtmId,
                gtmImgname,
                promoCreativeName,
                gtmPosition,
                storeType,
                pageName,
                pageType
              )
            : gtmPromotionCmsClick(
                gtmId,
                gtmImgname,
                promoCreativeName,
                gtmPosition,
                storeType,
                pageName,
                pageType
              );

          openModal();
        }}
      />
    </Fragment>
  );
};

const body = props => {
  const { hotspotUrl, metadata, hideModal, variant = 'desktop' } = props;
  const closeModal = useCallback(() => hideModal('video-image-modal'), []);
  return (
    <Modal name="video-image-modal" className="video-image-modal" show closeButton={false}>
      {hotspotUrl ? (
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <video
          className={`video__${variant}`}
          controls
          controlsList="nodownload"
          autoPlay={metadata ? metadata.autoPlay : false}
          disablePictureInPicture
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...(variant === 'mobile' ? { height: 'fit-content', width: '100%' } : {})}
        >
          <source src={hotspotUrl} />
        </video>
      ) : null}
      <div className="close-icon">
        <span role="presentation" className="ic-close-quickview" onClick={closeModal} />
      </div>
    </Modal>
  );
};

const mapStateToProps = state => {
  const modals = state ? state.modals : {};
  const videoModal = modals ? modals['video-image-modal'] : {};
  const modalDetails = videoModal ? videoModal.state : {};
  return {
    ...modalDetails
  };
};

const mapDispatchToProps = {
  showModal,
  hideModal
};

const VideoModalLink = connect(mapStateToProps, mapDispatchToProps)(Link);
const VideoModalBody = connect(mapStateToProps, mapDispatchToProps)(body);
export { VideoModalBody, VideoModalLink };
